var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAppleIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 26,
    height: 26,
    rx: 13,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9391 9.95396C19.8386 10.032 18.0635 11.0322 18.0635 13.2563C18.0635 15.8288 20.3222 16.7389 20.3898 16.7614C20.3794 16.8169 20.031 18.0078 19.1989 19.2213C18.457 20.2891 17.6821 21.3552 16.5033 21.3552C15.3245 21.3552 15.0212 20.6705 13.6603 20.6705C12.3342 20.6705 11.8627 21.3778 10.7845 21.3778C9.70622 21.3778 8.95388 20.3897 8.08886 19.1762C7.08689 17.7513 6.27734 15.5376 6.27734 13.4366C6.27734 10.0666 8.4685 8.27939 10.625 8.27939C11.7708 8.27939 12.726 9.03173 13.4454 9.03173C14.1301 9.03173 15.198 8.23432 16.5016 8.23432C16.9956 8.23432 18.7707 8.27939 19.9391 9.95396ZM15.8827 6.80764C16.4218 6.16798 16.8032 5.28042 16.8032 4.39287C16.8032 4.26979 16.7928 4.14498 16.7703 4.04443C15.8931 4.07737 14.8495 4.62863 14.2203 5.35843C13.7262 5.92009 13.2651 6.80764 13.2651 7.70733C13.2651 7.84255 13.2876 7.97776 13.298 8.0211C13.3535 8.0315 13.4437 8.04363 13.5338 8.04363C14.3208 8.04363 15.3106 7.51665 15.8827 6.80764Z",
    fill: "#0B0A0F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleIcon);
export default __webpack_public_path__ + "static/media/apple_icon.a47f6fd37ced10cb02800f73ec00fb7a.svg";
export { ForwardRef as ReactComponent };